const Axios = require('axios');
const focusHelper = require('base/components/focus');
const formUtils = require('../common/utils/formUtils');
const regexUtils = require('../common/utils/regex');
const { default: getFrontConfig } = require('../common/getFrontConfig');
const clientSideValidation = require('../components/clientSideValidation');
const base = require('../product/base');
const forms = require('../components/forms');
const { handleInitialExpandedClass } = require('../animations/dropDownCheck');
const summary = require('../checkout/summary');
const getAnalyticsEventBus = require('../common/getAnalyticsEventBus');

const analyticsEventBus = getAnalyticsEventBus();

const FRONT_CONFIG = getFrontConfig();

let updateSaveForLater = true;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
  let newUrl = url;
  newUrl +=
    (newUrl.indexOf('?') !== -1 ? '&' : '?') +
    Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');

  return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
  const cartErrorAmountSku = $('.cart-error-sku-amount-exceeded');
  const cartErrorMaxPrice = $('.cart-error-max-price-exceeded');

  if (data.valid.error) {
    if (
      data.valid.message ||
      data.cartMaxSKUAmountExceeded ||
      data.cartMaxPriceExceeded
    ) {
      if (data.valid.message) {
        const errorHtml = data.valid.link
          ? `${data.valid.message} <span class="cart-error__link ${data.valid.link.class}">` +
            `${data.valid.link.message}</span>`
          : `${data.valid.message}`;

        $('.cart-error').empty().append(errorHtml);
      }

      if (
        data.cartMaxSKUAmountExceeded &&
        data.resources.maxSKUAmountExceededMsg &&
        data.resources.maxSKUAmountExceededMsg !== ''
      ) {
        const errorHtml = `${data.resources.maxSKUAmountExceededMsg}`;

        cartErrorAmountSku.empty().append(errorHtml);
        cartErrorAmountSku.addClass('cart-error-sku-amount-exceeded--show');
      } else {
        clearCartError(
          cartErrorAmountSku,
          'cart-error-sku-amount-exceeded--show'
        );
      }

      if (
        data.cartMaxPriceExceeded &&
        data.resources.maxPriceExceededMsg &&
        data.resources.maxPriceExceededMsg !== ''
      ) {
        const errorHtml = `${data.resources.maxPriceExceededMsg}`;

        cartErrorMaxPrice.empty().append(errorHtml);
        cartErrorMaxPrice.addClass('cart-error-max-price-exceeded--show');
      } else {
        clearCartError(
          cartErrorMaxPrice,
          'cart-error-max-price-exceeded--show'
        );
      }
    } else {
      $('.cart')
        .empty()
        .append(
          `<div class="cart-empty"><p class="cart-empty__text"> ${
            data.resources.emptyCartMsg
          }</p></div>`
        );
      $('.number-of-items').empty().append(data.resources.numberOfItems);
      $('.minicart').trigger('count:update', { quantityTotal: data.numItems });
      $('body').trigger('header-popup:hide');
      document.body.classList.remove('body--cart');
    }

    $('.checkout-btn').addClass('disabled');
    $('.checkout-btn').attr('disabled', true);
  } else {
    $('.checkout-btn').removeClass('disabled');
    $('.checkout-btn').removeAttr('disabled');
    clearCartError(cartErrorAmountSku, 'cart-error-sku-amount-exceeded--show');
    clearCartError(cartErrorMaxPrice, 'cart-error-max-price-exceeded--show');
  }
}

/**
 * Remove cart errors
 */
function clearCartError(element, cssClass) {
  element.empty();
  element.removeClass(cssClass);
}

/**
 * Updates cart promotions row for given container
 * @param {JQuery} container - promotions container
 * @param {Object[]} promotions - promotions data
 * @param {string} promotions.name - promotion name
 * @param {Object} promotions.basePrice - promotion base price
 * @param {string} promotions.basePrice.formatted - promotion formatted base price
 */
function updatePromotions(container, promotions) {
  container.empty();
  promotions.forEach((item) => {
    // Main container
    const rowDiscount = document.createElement('div');
    rowDiscount.classList.add(
      'row',
      'order-discount',
      'discount-total-container',
      'totals__total'
    );

    // Promo naming
    const nameRowDiscount = document.createElement('p');
    nameRowDiscount.classList.add('discount-total-container__label');
    nameRowDiscount.textContent = item.name;
    rowDiscount.append(nameRowDiscount);

    // discount total amount
    const valueRowDiscount = document.createElement('p');
    valueRowDiscount.classList.add(
      'order-discount-total',
      'discount-total-container__price',
      'price-currency'
    );
    valueRowDiscount.textContent = `- ${item.basePrice.formatted}`;
    rowDiscount.append(valueRowDiscount);

    container.append(rowDiscount);
  });
}

/**
 * Updates the productLineItems & shipping promotion rows in cart totals
 * @param {Object} totals - Cart totals object
 * @param {Object} totals.appliedPromotions - Cart productLineItem applied promotions object
 * @param {Object} totals.shippingAppliedPromotions - Cart shipping applied promotions object
 */
function updatePromotionRows(totals) {
  const productLineItemsPromotionsContainer = $(
    '.promotion-discount-container'
  );
  updatePromotions(
    productLineItemsPromotionsContainer,
    totals.appliedPromotions
  );
  const shippingPromotionsContainer = $(
    '.promotion-discount-container--shipping'
  );
  updatePromotions(
    shippingPromotionsContainer,
    totals.shippingAppliedPromotions
  );
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
  $('.number-of-items').empty().append(data.resources.numberOfItems);
  $('.shipping-cost').empty().append(data.totals.totalShippingCost);
  $('.grand-total')
    .empty()
    .append(
      data.totals.grandTotal && data.totals.grandTotal !== '-'
        ? data.totals.grandTotal
        : data.totals.netGrandTotal
    );
  $('.sub-total').empty().append(data.totals.subTotal);
  $('.minicart').trigger('count:update', { quantityTotal: data.numItems });

  updatePromotionRows(data.totals);
  summary.updateTaxMessages(data.totals.totalTax);

  if (data.totals.shippingLevelDiscountTotal.value > 0) {
    $('.shipping-discount').removeClass('hide-shipping-discount');
    $('.shipping-discount-total')
      .empty()
      .append(`- ${data.totals.shippingLevelDiscountTotal.formatted}`);
  } else {
    $('.shipping-discount').addClass('hide-shipping-discount');
  }

  data.items.forEach((item) => {
    if (item.renderedPromotions) {
      $(`.item-${item.UUID}`).empty().append(item.renderedPromotions);
    }
    if (item.priceTotal && item.priceTotal.renderedPrice) {
      $(`.item-total-${item.UUID}`)
        .empty()
        .append(item.priceTotal.renderedPrice);
    }
  });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
  const errorHtml = `${'<div class="valid-cart-error fade show" role="alert">'}${message}</div>`;

  $('.cart-error').append(errorHtml);
}

/**
 * Empties cart-error element
 */
function removeErrorNotification() {
  $('.cart-error').empty();
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
  let html = '';
  $('.approaching-discounts').empty();
  if (approachingDiscounts.length > 0) {
    approachingDiscounts.forEach((item) => {
      html += `<div class="single-approaching-discount text-center">${
        item.discountMsg
      }</div>`;
    });
  }
  $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
  let lineItem;
  let messages = '';

  for (let i = 0; i < data.items.length; i++) {
    if (data.items[i].UUID === uuid) {
      lineItem = data.items[i];
      break;
    }
  }

  if (lineItem != null) {
    $(`.availability-${lineItem.UUID}`).empty();

    if (lineItem.availability) {
      if (lineItem.availability.messages) {
        lineItem.availability.messages.forEach((message) => {
          messages += `<p class="line-item-attributes">${message}</p>`;
        });
      }

      if (lineItem.availability.inStockDate) {
        messages += `<p class="line-item-attributes line-item-instock-date">${
          lineItem.availability.inStockDate
        }</p>`;
      }
    }

    $(`.availability-${lineItem.UUID}`).html(messages);
  }
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
  if ($('#editProductModal').length !== 0) {
    $('#editProductModal').remove();
  }
  const htmlString =
    '<!-- Modal -->' +
    '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">' +
    '<span class="enter-message sr-only" ></span>' +
    '<div class="modal-dialog quick-view-dialog">' +
    '<!-- Modal content-->' +
    '<div class="modal-content">' +
    '<div class="modal-header">' +
    '    <button type="button" class="close pull-right" data-dismiss="modal">' +
    '        <span aria-hidden="true">&times;</span>' +
    '        <span class="sr-only"> </span>' +
    '    </button>' +
    '</div>' +
    '<div class="modal-body"></div>' +
    '<div class="modal-footer"></div>' +
    '</div>' +
    '</div>' +
    '</div>';
  $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
  const $html = $('<div>').append($.parseHTML(html));

  const body = $html.find('.product-quickview');
  const footer = $html.find('.modal-footer').children();

  return { body, footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
  $('.modal-body').spinner().start();
  $.ajax({
    url: editProductUrl,
    method: 'GET',
    dataType: 'json',
    success(data) {
      const parsedHtml = parseHtml(data.renderedTemplate);

      $('#editProductModal .modal-body').empty();
      $('#editProductModal .modal-body').html(parsedHtml.body);
      $('#editProductModal .modal-footer').html(parsedHtml.footer);
      $('#editProductModal .modal-header .close .sr-only').text(
        data.closeButtonText
      );
      $('#editProductModal .enter-message').text(data.enterDialogMessage);
      $('#editProductModal').modal('show');
      $.spinner().stop();
    },
    error() {
      $.spinner().stop();
    },
  });
}

function toggleOptionVisibility(option) {
  $(option)
    .find('form')
    .each(function clearEachFormErrors() {
      forms.clearFormErrors(this);
    });
  $('.drop-down-check__toggler', option).trigger('click');
}

function toggleOptionSelection(option) {
  $('.btn-radio', option).toggleClass('btn-radio--selected');
  $(option).toggleClass('cart-option--selected');
}

/**
 * Return the product card DOM element for a given product line item UUID
 * @author on4u
 * @param {string} UUID product line item UUID
 * @returns {jQuery} jQuery object of the product card
 */
function findProductCardFromUUID(UUID) {
  return $(`.product-card.uuid-${UUID}`);
}

/**
 * Return the quantity number for a given product card
 * @author on4u
 * @param {jQuery} productCard - product card
 * @returns {number} - quantity
 */
function getProductQuantity(productCard) {
  return parseInt(
    $('.quantity-form', productCard).attr('data-pre-select-qty'),
    10
  );
}

function updateProductCardLiterals(productCard, quantity) {
  $('.quantity-label', productCard)
    .empty()
    .append(`x (${parseInt(quantity, 10)})`);
  $('.quantity-form', productCard).attr('data-pre-select-qty', quantity);
}

/**
 * Sets the plus qty product as enabled/disabled according to product qty and ats
 * @param  {array} items - lineItems array
 * @param  {Object} productCard - productCard DOM jQuery object
 * @param  {number} UUID - product UUID
 */
function updatePlusQty(items, productCard, UUID) {
  for (let i = 0; i < items.length; i++) {
    if (items[i].UUID === UUID) {
      const lineItem = items[i];
      if (lineItem.quantity >= lineItem.ATS) {
        $('.plus-product-qty', productCard).addClass('disabled');
      } else {
        $('.plus-product-qty', productCard).removeClass('disabled');
      }
    }
  }
}

/**
 * Code to change product quantity taken from SFRA's changeProductQty().
 * Now its possible to run this action outside a product line item DOM
 *
 * @author on4u
 * @param {string} updateQuantityUrl
 * @param {string} productID
 * @param {number} quantity
 * @param {string} UUID
 * @param {JQuery} [productCard]
 * @return {Cart} Cart model (Cart-UpdateQuantity response)
 */
async function doChangeProductQty(
  updateQuantityUrl,
  productID,
  quantity,
  UUID,
  productCard = false
) {
  if (!productCard) {
    // eslint-disable-next-line no-param-reassign
    productCard = findProductCardFromUUID(UUID);
  }

  const urlParams = {
    pid: productID,
    quantity,
    uuid: UUID,
  };
  const url = appendToUrl(updateQuantityUrl, urlParams);

  $('body').trigger('cart:beforeUpdate');

  let response;
  await $.ajax({
    url,
    type: 'get',
    context: this,
    dataType: 'json',
    /**
     * Handle success
     * @param {Cart} cart
     */
    success(cart) {
      response = cart;
      $('.coupons-and-promos').empty().append(cart.totals.discountsHtml);
      updateCartTotals(cart);
      updateApproachingDiscounts(cart.approachingDiscounts);
      updateAvailability(cart, UUID);
      validateBasket(cart);
      updateProductCardLiterals(productCard, quantity);
      updatePlusQty(cart.items, productCard, UUID);

      $('body').trigger('cart:update', cart);
      $('body').trigger('storeCart:updateItem', { cart, UUID });
      $('body').trigger('product:updateQuantity', cart);

      if (
        $('.product-info', productCard).hasClass('bonus-product-line-item') &&
        $('.cart-content').length
      ) {
        window.location.reload();
      }
    },
    error(err) {
      if (err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      } else {
        $('.plus-product-qty', productCard).addClass('disabled');
        createErrorNotification(err.responseJSON.errorMessage);
        setTimeout(removeErrorNotification, 3000);
      }
    },
  });

  return response;
}

function updateCart(data, UUID) {
  const basket = data.basket ? data.basket : data.cart;
  function emptyCart() {
    $('.cart').html(
      `<div class="cart-empty"><p class="cart-empty__text"> ${
        basket.resources.emptyCartMsg
      }</p></div>`
    );
    $('.number-of-items').html(basket.resources.numberOfItems);
    $('.minicart').trigger('count:update', { quantityTotal: basket.numItems });
    $('.minicart .popover').empty();
    $('.minicart .popover').removeClass('show');
    $('body').removeClass('modal-open');
    $('html').removeClass('veiled');
  }
  if (basket.items.length === 0) {
    const $pc = $('.cart .product-card');
    if ($pc) {
      // animate product-card deletion before emptying the last existing cart
      $pc.trigger('interaction--delete-card-event');
      setTimeout(() => {
        emptyCart();
      }, 300);
    } else {
      emptyCart();
    }
  } else {
    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
      for (let i = 0; i < data.toBeDeletedUUIDs.length; i++) {
        $($(`.uuid-${data.toBeDeletedUUIDs[i]}`)[0]).trigger(
          'interaction--delete-card-event'
        );
      }
    }
    if (UUID) {
      $(`.product-card.uuid-${UUID}`).each(function transitionEachCard() {
        $(this).trigger('interaction--delete-card-event');
        $(this).data('available', true);
      });
    }
    if (!basket.hasBonusProduct) {
      $('.bonus-product').remove();
    }
    $('.coupons-and-promos').html(basket.totals.discountsHtml);
    updateCartTotals(basket);
    updateApproachingDiscounts(basket.approachingDiscounts);
    $('body').trigger('setShippingMethodSelection', basket);
    validateBasket(basket);
  }

  if (data.saveForLater) {
    $('.save-for-later-size').html(`(${data.saveForLater.quantity})`);
  }
}

/**
 * Code to change product quantity taken from SFRA's
 * $('body').on('click', '.remove-product--cart', function () { ... })
 * Now its possible to run this action from different listeners
 *
 * @author on4u
 * @param {string} removeProductLineItemUrl
 * @param {string} productID
 * @param {string} UUID
 * @return {any} async response
 */
async function removeProduct(removeProductLineItemUrl, productID, UUID) {
  const urlParams = {
    pid: productID,
    uuid: UUID,
  };

  const url = appendToUrl(removeProductLineItemUrl, urlParams);

  $('body').trigger('cart:beforeUpdate');

  let response;
  await $.ajax({
    url,
    type: 'get',
    dataType: 'json',
    async success(data) {
      response = data;
      updateCart(data, UUID);
      $('body').trigger('cart:update', data);
      $('body').trigger('storeCart:removeItem', productID);
      $('body').trigger('product:removeFromCart', data);
    },
    error(err) {
      if (err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      } else {
        createErrorNotification(err.responseJSON.errorMessage);
        setTimeout(removeErrorNotification, 3000);
      }
    },
  });

  return response;
}

/**
 * Remove product from SFL
 * @author on4u
 * @param {string} url
 * @param {string} productID
 * @param {string} UUID
 *
 * @return {any} ajax response data if success else false
 */
function removeSaveForLaterProduct(url, productID, UUID) {
  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: {
      pid: productID,
    },
    success(data) {
      if (data.saveForLater) {
        $($(`.uuid-${UUID}`)[0]).trigger('interaction--delete-card-event');
        $('.save-for-later-size').html(`(${data.saveForLater.quantity})`);

        if (data.saveForLater.products.length === 0) {
          const SFLContainer = $('.save-for-later-container');
          const emptySFLhtml = `<p class='save-for-later-empty'>${SFLContainer.attr(
            'data-empty-text'
          )}</p>`;
          SFLContainer.html(emptySFLhtml);
          updateSaveForLater = true;
          $('body').trigger('save-for-later:do-update');
        }
      }
      return data;
    },
    error(err) {
      if (err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      } else {
        createErrorNotification(err.responseJSON.errorMessage);
        setTimeout(removeErrorNotification, 3000);
      }
    },
  });

  return false;
}

/**
 * Updates cart error message
 * @param  {Object} cart - Cart DOM jQuery element
 *
 * @returns {boolean} true if error message is shown, else false
 */
function updateCartError(cart) {
  const cartError = $('.cart-error', cart);
  const cartErrorAmountSku = $('.cart-error-sku-amount-exceeded', cart);
  const cartErrorMaxPrice = $('.cart-error-max-price-exceeded', cart);
  let showError = false;

  $('.product-card', cart).each(function checkEachProductCard() {
    if (!$(this).data('available') || $(this).data('available') === 'limited') {
      showError = true;
      cartError.addClass('cart-error--show');
    }
  });

  if (cart.cartMaxSKUAmountExceeded) {
    showError = true;
    cartErrorAmountSku.addClass('cart-error-sku-amount-exceeded--show');
  }

  if (cart.cartMaxPriceExceeded) {
    showError = true;
    cartErrorMaxPrice.addClass('cart-error-max-price-exceeded--show');
  }

  if (showError) {
    return true;
  }

  cartError.removeClass('cart-error--show');
  cartErrorAmountSku.removeClass('cart-error-sku-amount-exceeded--show');
  cartErrorMaxPrice.removeClass('cart-error-max-price-exceeded--show');
  return false;
}

/**
 * Adds the productCard to the Save For Later
 * @param  {jquery} cart - jQuery DOM cart container
 * @param  {jquery} productCard - jQuery DOM productCard to be added to Save for Later
 */
function addToSaveLater(cart, productCard) {
  const pid = productCard.attr('data-product-id');
  const saveForLaterButton = $('.btn-save-for-later', productCard);
  const url = saveForLaterButton.attr('data-action');
  const UUID = saveForLaterButton.attr('data-uuid');
  const qty = saveForLaterButton.attr('data-quantity');
  const ats = saveForLaterButton.attr('data-ats');
  const isLimited = saveForLaterButton.data('is-limited');
  let formData;

  if (isLimited && parseInt(ats, 10) !== 0) {
    // Update product quantity to ATS
    changeProductQty(ats, productCard);

    // Send quantity surplus (quantity - ATS) to SFL
    formData = {
      pid,
      quantity: qty - ats,
      removeProduct: false,
    };
  } else {
    formData = {
      pid,
    };
  }

  $('body').trigger('cart:beforeUpdate');

  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: formData,
    success(data) {
      $('body').trigger('cart:update', data);
      if (isLimited) {
        updateCart(data);
        $('body').trigger('cart:do-update');
      } else {
        updateCart(data, UUID);
        updateCartError(cart);
      }

      // launch animation if request is successfully completed.
      productCard.each(function transitionDP6ProductCard() {
        $(this).trigger('interaction--delete-card-event');
      });
      updateSaveForLater = true;
      $('body').trigger('save-for-later:do-update');
      $('body').trigger('storeCart:removeItem', pid);
      $('body').trigger('product:removeFromCart', data);
    },
    error(err) {
      if (err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      } else {
        createErrorNotification(err.responseJSON.errorMessage);
        setTimeout(removeErrorNotification, 3000);
      }
    },
  });
}

function changeProductQty(quantity, productCard) {
  const quantityForm = $('.quantity-form', productCard);
  const productID = quantityForm.attr('data-pid');
  const url = quantityForm.attr('data-action');
  const uuid = quantityForm.attr('data-uuid');
  doChangeProductQty(url, productID, quantity, uuid, productCard);
}

function validatePersonalizeBusinessData() {
  // Form business logic validation
  return true;
}

function checkoutBtnHandler(e) {
  const button = e.currentTarget;
  const $button = $(button);
  const cart = $button.closest('.cart');
  let $form = $button.closest('form');
  if ($form.length === 0) {
    $form = $('form.option-personalize__form');
  }
  const form = $form[0]; // jq to element
  const $wrapper = $form.closest('.option-personalize');
  const isTextareaExpanded =
    $wrapper.hasClass('interaction--expand') &&
    $wrapper.hasClass('interaction-active');
  let isFormatValid = true;

  // check textarea format validity only if it is visible
  if (isTextareaExpanded) {
    // first we need to trigger a blur to force a recalculation
    // we might have a prefilled text that is not prevalidated
    const $textarea = $form.find('textarea');
    $textarea.trigger('blur');
    isFormatValid = clientSideValidation.functions.validateFormatData(form);
  }

  if (isFormatValid) {
    const isBusinessValid = validatePersonalizeBusinessData(form);

    if (isBusinessValid) {
      if (!updateCartError(cart)) {
        window.location.href = $button.data('href');
      }
    }
  }
}

/**
 * Attach all the event handlers nedded for cart functionality
 * @returns {void}
 */
function attachEventHandlers() {
  $('body').on(
    'cart:removeProductLineItem',
    /**
     * Handle remove product command
     * @param {jQuery.Event} evt
     * @param {Object} payload
     * @param {string} payload.removeProductLineItemUrl - URL to remove endpoint
     * @param {ProductLineItem} payload.productLineItem - line item to remove from cart
     */
    (evt, payload) => {
      removeProduct(
        payload.removeProductLineItemUrl,
        payload.productLineItem.id,
        payload.productLineItem.UUID
      );
    }
  );

  $('body').on('cart:updateProductQty', (evt, data) => {
    const { updateQuantityUrl, productID, quantity, UUID } = data;
    doChangeProductQty(updateQuantityUrl, productID, quantity, UUID);
  });

  $('body').on('click', '.remove-product--cart', function removeCartProduct(e) {
    e.preventDefault();

    const productID = $(this).data('pid');
    const uuid = $(this).data('uuid');
    const url = $(this).data('action');
    removeProduct(url, productID, uuid);
  });

  $('body').on('click', '.minus-product-qty', function minusProductHandler() {
    const productCard = $(this).parents('.product-card');
    const qty = getProductQuantity(productCard) - 1;
    if (qty === 0) {
      const removeProductBtn = $('.remove-product', productCard);
      if (removeProductBtn.length > 0) {
        const productID = removeProductBtn.data('pid');
        const uuid = removeProductBtn.data('uuid');
        const url = removeProductBtn.data('action');
        removeProduct(url, productID, uuid);
      }
    } else {
      changeProductQty(qty, productCard);
    }
  });

  $('body').on('click', '.plus-product-qty', function plusProductHandler() {
    const productCard = $(this).parents('.product-card');
    const qty = getProductQuantity(productCard) + 1;
    changeProductQty(qty, productCard);
  });

  $('.shippingMethods').change(function changeShippingMethods() {
    const url = $(this).attr('data-actionUrl');
    const urlParams = {
      methodID: $(this).find(':selected').attr('data-shipping-id'),
    };
    // url = appendToUrl(url, urlParams);

    $('.totals').spinner().start();
    $('body').trigger('cart:beforeShippingMethodSelected');
    $.ajax({
      url,
      type: 'post',
      dataType: 'json',
      data: urlParams,
      success(data) {
        if (data.error) {
          window.location.href = data.redirectUrl;
        } else {
          $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
          updateCartTotals(data);
          updateApproachingDiscounts(data.approachingDiscounts);
          validateBasket(data);
        }
        $('body').trigger('cart:shippingMethodSelected', data);
        $.spinner().stop();
      },
      error(err) {
        if (err.redirectUrl) {
          window.location.href = err.redirectUrl;
        } else {
          createErrorNotification(err.responseJSON.errorMessage);
          setTimeout(removeErrorNotification, 3000);
          $.spinner().stop();
        }
      },
    });
  });

  // Toggle coupon check on click
  $('body').on(
    'click',
    '.cart-option--coupon .drop-down-check__toggler',
    (e) => {
      toggleOptionSelection($(e.target).closest('.cart-option--coupon'));
    }
  );

  // Enable/disable coupon submit button
  $('body').on(
    'change keyup',
    '#couponCode',
    function toggleCouponSubmitButton() {
      const submitButton = $('.cart-option__submit-button');
      if (submitButton) {
        if ($(this).val()) {
          submitButton.removeAttr('disabled');
        } else {
          submitButton.attr('disabled', 'true');
        }
      }
    }
  );

  $(document).on('submit', '.promo-code-form', function addPromoCode(e) {
    e.preventDefault();
    const $form = $(this);
    $('.coupon-error', $form).addClass('d-none');
    $('.coupon-missing-error').hide();
    $('.promo-code-form .form-control').removeClass('is-invalid');
    $('.coupon-error-message').empty();

    if (!$('.coupon-code-field', $form).val()) {
      $('.coupon-error', $form).removeClass('d-none');
      $('.promo-code-form .form-control').addClass('is-invalid');
      $('.coupon-missing-error').show();
      return false;
    }

    $('body').trigger('promotion:beforeUpdate');

    $.ajax({
      url: $form.attr('action'),
      type: 'GET',
      dataType: 'json',
      data: $form.serialize(),
      success(data) {
        if (data.error) {
          $('.coupon-error', $form).removeClass('d-none');
          $('.promo-code-form .form-control').addClass('is-invalid');
          $('.coupon-error-message').empty().append(data.errorMessage);
          analyticsEventBus.publish(
            analyticsEventBus.EVENTS.couponAppliedErrorCode,
            data.errorCode
          );
        } else {
          $('.coupons-and-promos').empty().append(data.totals.discountsHtml);

          updateCartTotals(data);
          updateApproachingDiscounts(data.approachingDiscounts);
          validateBasket(data);

          const button = $form[0].querySelector(
            '.cart-option__submit-button.interaction--swap-text'
          );
          $('body').trigger('interaction--swap-text-event', button);
        }

        $('.coupon-code-field', $form).val('');
      },
      error(err) {
        $('body').trigger('promotion:error', err);
        if (err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        } else {
          createErrorNotification(err.errorMessage);
          setTimeout(removeErrorNotification, 3000);
        }
      },
    });
    return false;
  });

  $('body').on('click', '.remove-coupon', function removeCoupon(e) {
    e.preventDefault();

    const $button = $(this);
    let url = $button.data('action');
    const uuid = $button.data('uuid');
    const couponCode = $button.data('code');
    const urlParams = {
      code: couponCode,
      uuid,
    };

    if (!uuid) {
      $('.coupon-code-field').val('');
      return;
    }

    url = appendToUrl(url, urlParams);

    $.ajax({
      url,
      type: 'get',
      dataType: 'json',
      success(data) {
        $('.coupon-code-field').val('');
        $(`.coupon-uuid-${uuid}`).remove();

        updateCartTotals(data);
        updateApproachingDiscounts(data.approachingDiscounts);
        validateBasket(data);
      },
      error(err) {
        if (err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        } else {
          createErrorNotification(err.responseJSON.errorMessage);
          setTimeout(removeErrorNotification, 3000);
        }
      },
    });
  });

  $('body').on(
    'click',
    '.cart-content .bonus-product-button',
    function clickBonusProduct() {
      $.spinner().start();
      $(this).addClass('launched-modal');
      $.ajax({
        url: $(this).data('url'),
        method: 'GET',
        dataType: 'json',
        success(data) {
          base.methods.editBonusProducts(data);
          $.spinner().stop();
        },
        error() {
          $.spinner().stop();
        },
      });
    }
  );

  $('body').on('hidden.bs.modal', '#chooseBonusProductModal', () => {
    $('#chooseBonusProductModal').remove();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');

    if ($('.cart-content').length) {
      $('.launched-modal .btn-outline-primary').trigger('focus');
      $('.launched-modal').removeClass('launched-modal');
    } else {
      $('.product-detail .add-to-cart').focus();
    }
  });

  $('body').on(
    'click',
    '.cart-content .product-edit .edit, .cart-content .bundle-edit .edit',
    function editCartProduct(e) {
      e.preventDefault();

      const editProductUrl = $(this).attr('href');
      getModalHtmlElement();
      fillModalElement(editProductUrl);
    }
  );

  $('body').on('shown.bs.modal', '#editProductModal', () => {
    $('#editProductModal').siblings().attr('aria-hidden', 'true');
    $('#editProductModal .close').focus();
  });

  $('body').on('hidden.bs.modal', '#editProductModal', () => {
    $('#editProductModal').siblings().attr('aria-hidden', 'false');
  });

  $('body').on('keydown', '#editProductModal', (e) => {
    const focusParams = {
      event: e,
      containerSelector: '#editProductModal',
      firstElementSelector: '.close',
      lastElementSelector: '.update-cart-product-global',
      nextToLastElementSelector: '.modal-footer .quantity-select',
    };
    focusHelper.setTabNextFocus(focusParams);
  });

  $('body').on('product:updateAddToCart', (e, response) => {
    // update global add to cart (single products, bundles)
    const dialog = $(response.$productContainer).closest('.quick-view-dialog');

    $('.update-cart-product-global', dialog).attr(
      'disabled',
      !$('.global-availability', dialog).data('ready-to-order') ||
        !$('.global-availability', dialog).data('available')
    );
  });

  $('body').on('product:updateAvailability', (e, response) => {
    // bundle individual products
    $('.product-availability', response.$productContainer)
      .data('ready-to-order', response.product.readyToOrder)
      .data('available', response.product.available)
      .find('.availability-msg')
      .empty()
      .html(response.message);

    const dialog = $(response.$productContainer).closest('.quick-view-dialog');

    if ($('.product-availability', dialog).length) {
      // bundle all products
      const allAvailable = $('.product-availability', dialog)
        .toArray()
        .every((item) => $(item).data('available'));

      const allReady = $('.product-availability', dialog)
        .toArray()
        .every((item) => $(item).data('ready-to-order'));

      $('.global-availability', dialog)
        .data('ready-to-order', allReady)
        .data('available', allAvailable);

      $('.global-availability .availability-msg', dialog)
        .empty()
        .html(
          allReady ? response.message : response.resources.info_selectforstock
        );
    } else {
      // single product
      $('.global-availability', dialog)
        .data('ready-to-order', response.product.readyToOrder)
        .data('available', response.product.available)
        .find('.availability-msg')
        .empty()
        .html(response.message);
    }
  });

  $('body').on('product:afterAttributeSelect', (e, response) => {
    if ($('.modal.show .product-quickview .bundle-items').length) {
      $('.modal.show')
        .find(response.container)
        .data('pid', response.data.product.id);
      $('.modal.show')
        .find(response.container)
        .find('.product-id')
        .text(response.data.product.id);
    } else {
      $('.modal.show .product-quickview').data('pid', response.data.product.id);
    }
  });

  $('body').on('change', '.quantity-select', function changeQuantity() {
    const selectedQuantity = $(this).val();
    $('.modal.show .update-cart-url').data(
      'selected-quantity',
      selectedQuantity
    );
  });

  $('body').on('change', '.options-select', function changeOptions() {
    const selectedOptionValueId = $(this)
      .children('option:selected')
      .data('value-id');
    $('.modal.show .update-cart-url').data(
      'selected-option',
      selectedOptionValueId
    );
  });

  $('body').on(
    'click',
    '.update-cart-product-global',
    function updateCartProductGlobal(e) {
      e.preventDefault();

      /**
       * Updates details of a product line item
       * @param {Object} data - AJAX response from the server
       * @param {string} uuid - The uuid of the product line item to update
       */
      function updateProductDetails(data, uuid) {
        document.querySelector(`.card.product-info.uuid-${uuid}`).outerHTML =
          data.renderedTemplate;
      }

      const updateProductUrl = $(this)
        .closest('.cart-and-ipay')
        .find('.update-cart-url')
        .val();
      const selectedQuantity = $(this)
        .closest('.cart-and-ipay')
        .find('.update-cart-url')
        .data('selected-quantity');
      const selectedOptionValueId = $(this)
        .closest('.cart-and-ipay')
        .find('.update-cart-url')
        .data('selected-option');
      const uuid = $(this)
        .closest('.cart-and-ipay')
        .find('.update-cart-url')
        .data('uuid');

      const form = {
        uuid,
        pid: base.getPidValue($(this)),
        quantity: selectedQuantity,
        selectedOptionValueId,
      };

      $(this).parents('.card').spinner().start();
      if (updateProductUrl) {
        $('body').trigger('cart:beforeUpdate');
        $.ajax({
          url: updateProductUrl,
          type: 'post',
          context: this,
          data: form,
          dataType: 'json',
          success(data) {
            $('#editProductModal').modal('hide');

            $('.coupons-and-promos')
              .empty()
              .append(data.cartModel.totals.discountsHtml);
            updateCartTotals(data.cartModel);
            updateApproachingDiscounts(data.cartModel.approachingDiscounts);
            updateAvailability(data.cartModel, uuid);
            updateProductDetails(data, uuid);

            if (data.uuidToBeDeleted) {
              $(`.uuid-${data.uuidToBeDeleted}`).remove();
            }

            validateBasket(data.cartModel);
            $('body').trigger('cart:update', data);

            $.spinner().stop();
          },
          error(err) {
            if (err.responseJSON.redirectUrl) {
              window.location.href = err.responseJSON.redirectUrl;
            } else {
              createErrorNotification(err.responseJSON.errorMessage);
              setTimeout(removeErrorNotification, 3000);
              $.spinner().stop();
            }
          },
        });
      }
    }
  );

  $('body').on(
    'click',
    '.cart-option--personalize .drop-down-check__toggler',
    function saveIsGiftHandler() {
      const option = $(this).closest('.cart-option--personalize');

      Axios.post(
        option.data('action'),
        { isGift: !option.hasClass('cart-option--selected') },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
        .then((response) => {
          const { data } = response;
          if (data.success) {
            toggleOptionSelection(option);
          } else {
            toggleOptionVisibility(option);
          }
        })
        .catch((error) => {
          if (error.responseJSON?.redirectUrl) {
            window.location.href = error.responseJSON.redirectUrl;
          } else {
            toggleOptionVisibility(option);
          }
        });
      return false;
    }
  );

  // Auto-remove emojis gift-text
  $('body').on(
    'change keyup',
    '.option-personalize__gift-text',
    function removeEmojisGiftText() {
      $(this).val(regexUtils.removeEmoji($(this).val()));
    }
  );

  $('body').on(
    'focusout',
    '.option-personalize__gift-text',
    function submitPersonalizeForm(event) {
      event.preventDefault();
      const form = $(this).closest('.option-personalize__form');
      const fieldTextarea = $(this).closest('.field-textarea');

      if (fieldTextarea.hasClass('field-textarea--is-invalid')) {
        fieldTextarea.removeClass('field-textarea--is-invalid');
        $('.field-textarea__error-message', fieldTextarea).removeClass(
          'transition-ap8--show'
        );
      }

      Axios.post(form.attr('action'), formUtils.getFormData(form[0]), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          const { data } = response;
          if (data.error) {
            fieldTextarea.addClass('field-textarea--is-invalid');
            $('.field-textarea__error-message', fieldTextarea).addClass(
              'transition-ap8--show'
            );
          }
        })
        .catch((error) => {
          if (error.responseJSON?.redirectUrl) {
            window.location.href = error.responseJSON.redirectUrl;
          }
        });
      return false;
    }
  );

  $('body').on(
    'click',
    '.cart-container__tab',
    function updateCartContentTab(event) {
      event.preventDefault();

      const newContent = $(this).attr('data-content');
      $('body').trigger(`${newContent}:do-update`);
      $('body').trigger('cart:toggleTab', newContent);
    }
  );

  $('body').on('product:afterAddToCart', async (event, data) => {
    if (data.product) {
      let productCard;
      if (data.saveForLater) {
        productCard = $(
          `.save-for-later-container .product-card[data-product-id="${data.product.id}"]`
        );
      } else if (data.wishlist) {
        productCard = $(
          `.wishlist-container .product-card[data-product-id="${data.product.id}"]`
        );
      } else {
        productCard = $(
          `.cart-content .product-card[data-product-id="${data.product.id}"]`
        );
      }

      if (productCard.length) {
        if (data.removeFromSFL) {
          updateCart(data, productCard.attr('data-uuid'));
        } else {
          updateCart(data);
        }
        updateSaveForLater = true;
        $('body').trigger('cart:do-update');
        $('body').trigger('save-for-later:do-update');
      } else {
        updateCart(data);
      }
    }
  });

  $('body').on('click', '.checkout-btn', checkoutBtnHandler);

  $('body').on('cart:init cart:do-update', () => {
    $('.cart-content').each(function updateEachCartContent() {
      const dropDownCheckButton = $(
        '.cart-option--personalize .drop-down-check__button',
        $(this)
      );
      const dropDownCheckContent = $(
        '.cart-option--personalize .interaction--expand',
        $(this)
      );
      handleInitialExpandedClass(dropDownCheckButton, dropDownCheckContent);
    });
  });
}

/**
 * Attach all the event handlers nedded for save for later
 * @returns {void}
 */
function attachSaveForLaterEventHandlers() {
  $('body').on(
    'click',
    '.btn-save-for-later',
    function saveForLaterHandler(event) {
      event.preventDefault();

      const cart = $(this).closest('.cart');
      const UUID = $(this).attr('data-uuid');
      const productCard = $(`.product-card.uuid-${UUID}`);

      addToSaveLater(cart, productCard);
    }
  );

  $('body').on(
    'click',
    '.save-for-later-all',
    function saveForLaterAllHandler(event) {
      event.preventDefault();

      const cart = $(this).closest('.cart');
      $(
        '.product-card[data-available="false"], .product-card[data-available="limited"]',
        cart
      ).each(function addEachToSaveForLater() {
        addToSaveLater(cart, $(this));
      });
    }
  );

  $('body').on('save-for-later:update', () => {
    updateSaveForLater = true;
  });

  $('body').on('save-for-later:do-update', () => {
    if (updateSaveForLater) {
      const url = $('.cart-container__tab--save-for-later').attr('data-url');
      $.get(url, (data) => {
        $('.cart-container').each(function updateCartContent() {
          const newContainer = $(
            '.save-for-later-container.cart-container__save-for-later-element',
            this
          );
          newContainer.empty();
          newContainer.append(data);
          updateSaveForLater = false;
        });
      });
      $('body').trigger('byl:tabs.shown');
    }
  });

  $('body').on(
    'click',
    '.remove-product--save-for-later',
    function removeSaveForLaterHandler(e) {
      e.preventDefault();

      const productID = $(this).data('pid');
      const uuid = $(this).data('uuid');
      const url = $(this).data('action');
      removeSaveForLaterProduct(url, productID, uuid);
      updateSaveForLater = true;
    }
  );
}

/**
 * Attach all the event handlers nedded for wishlist
 * @returns {void}
 */
function attachWishlistEventHandlers() {
  $('body').on('wishlist:do-update', () => {
    const url = $('.cart-container__tab--wishlist').attr('data-url');
    $.get(url, (data) => {
      $('.cart-container').each(function updateCartContent() {
        const newContainer = $(
          '.wishlist-container.cart-container__wishlist-element',
          this
        );
        newContainer.empty();
        newContainer.append(data);
      });
      $('body').trigger('wishlist:updated');
      $('body').trigger('byl:tabs.shown');
    });
  });
}

/**
 * Initialize the cart module
 * @returns {void}
 */
function init() {
  attachEventHandlers();

  if (FRONT_CONFIG.isSaveForLaterEnabled) {
    attachSaveForLaterEventHandlers();
  }
  if (FRONT_CONFIG.isWishlistEnabled) {
    attachWishlistEventHandlers();
  }

  $(window).on('load', () => {
    const pageType = document.querySelector('.page').dataset.action;
    if (pageType === 'Cart-Show') {
      $('body').trigger('cart:init');
    }
  });

  $('body').on('cart:init cart:do-update', () => {
    $('.cart-content').each(function updateEachCartContent() {
      const dropDownCouponCheckButton = $(
        '.cart-option--coupon .drop-down-check__button',
        $(this)
      );
      const dropDownCouponCheckContent = $(
        '.cart-option--coupon .interaction--expand',
        $(this)
      );
      handleInitialExpandedClass(
        dropDownCouponCheckButton,
        dropDownCouponCheckContent
      );
    });
  });

  base.bylCustomInit();
  base.selectAttribute();
  base.colorAttribute();
  base.removeBonusProduct();
  base.selectBonusProduct();
  base.enableBonusProductSelection();
  base.showMoreBonusProducts();
  base.addBonusProductsToCart();
  base.focusChooseBonusProductModal();
  base.trapChooseBonusProductModalFocus();
  base.onClosingChooseBonusProductModal();
}

module.exports = {
  init,
  /**
   * Check if the user is visiting the cart page
   * @returns {boolean} true if the cart page is loaded
   */
  isCartPage: function isCartPage() {
    return !!document.querySelector('.cart-page');
  },
};
